import React from 'react';
import SplitList from './SplitList';
import { splitListReadValue } from './constants';
import { DetailItem } from './SectionCard';
import NowName from '../shared/NowName';
import { PROFILE_SPLIT_GROUPS, groupSplit, groupText, profileForEntity } from '../../utils/engagementProfile';

// Read side of the per-company client profile (src/utils/engagementProfile.js)
// — the Registration, Screening request and Screening record detail pages.

const profileGroup = (key) => PROFILE_SPLIT_GROUPS.find((g) => g.key === key);

/** "<Question> per Company": one row per company with its own answer. */
export const ProfilePerCompany = ({ request, groupKey }) => {
  const group = profileGroup(groupKey);
  return (
    <SplitList
      controlClass={splitListReadValue}
      rows={(request.entities || []).map((e) => ({
        key: e.id,
        title: <NowName value={e.entityName} now={e.entityNameNow} />,
        control: groupText(group, profileForEntity(request, e)) || '—',
      }))}
    />
  );
};

/**
 * One profile answer as a DetailItem — per company when the companies answer
 * it on their own (the comment anchor is then `<group>Split`, the History
 * row's key), else the shared answer (`children`, or the group's own text).
 */
export const ProfileDetailItem = ({ request, groupKey, label, field = undefined, children = undefined }) => {
  const group = profileGroup(groupKey);
  if (groupSplit(request.entities || [], group)) {
    return (
      <DetailItem label={`${label} per Company`} field={field ? `${groupKey}Split` : undefined}>
        <ProfilePerCompany request={request} groupKey={groupKey} />
      </DetailItem>
    );
  }
  return <DetailItem label={label} field={field}>{children !== undefined ? children : (groupText(group, request) || '—')}</DetailItem>;
};
